import { useNextMicro, useUpdate } from '@bydesign-ui/hooks';
import { useContext, useEffect } from 'react';
import { RangeTimeContext } from '../context/rangeTime';
import { useTime } from './useTime';
export function useTimeView() {
  var update = useNextMicro(useUpdate());
  var time = useTime();
  var rangeTime = useContext(RangeTimeContext);
  time.root = rangeTime;
  useEffect(function () {
    time.addListener('repaint', update);
    return function () {
      return time.removeListener('repaint', update);
    };
  }, []);
  return time;
}